import { BetRankingTypeId } from '@/models/bet/ranking/type';
import { GameDetailsTabsOptions } from '../Tabs/props';
import GameDetailsContentDescription from './Description';
import { GameDetailsContentRenderProps } from './props';
import GameDetailsContentRenderer from './Renderer';

export default function GameDetailsContentRender({
  current,
}: GameDetailsContentRenderProps) {
  switch (current) {
    case GameDetailsTabsOptions.HighWin:
      return <GameDetailsContentRenderer typeId={BetRankingTypeId.Payout} />;
    case GameDetailsTabsOptions.LuckyWin:
      return (
        <GameDetailsContentRenderer typeId={BetRankingTypeId.Multiplier} />
      );
    case GameDetailsTabsOptions.Description:
      return <GameDetailsContentDescription />;
    case GameDetailsTabsOptions.Review:
      return;
  }
}
